import React, { useState } from "react";
import { Grid } from '@mui/material';

import Toolbar from '@mui/material/Toolbar';
import Card from "@mui/material/Card";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { useNavigate, useParams } from 'react-router-dom';


import { gql, useQuery } from '@apollo/client';
import * as types from "../gql/graphql";

import EditEventDialog from "./EditEventDialog";
import EditEventAttendees from './EditEventAttendees';
//import EditEventWaitList from "./EditEventWaitList";
import EditEventInstructors from "./EditEventInstructors";
import EventRoster from "./EventRoster";

import MDBoxRoot from './MDBox/MDBoxRoot';
import MDTypographyRoot from "./MDTypography/MDTypographyRoot";

import { useScreenSize } from "../hooks/ScreenSizeContext";
import { SchoolTime } from "../utils/SchoolTime";
import { useQueryAll } from "../apolloClient";

const getEventQuery = gql(`
  query GetEvent($id:BigInt) {
    fs_eventsCollection(filter: {id: {eq: $id}}) {
        edges {
          node {
            nodeId
            id
            class
            fs_classes { name followupmsg }
            capacity
            date
            status
            notes
            replicated_from         
          }
        }
      }
  }`);

const getStaffStatus = gql(`
    query GetStaffStatusE {
      am_i_staff
    }
    `);

// Get all signups and WL signups for the event. TODO: Switch to useAllItems
const getClassSignupsQuery = gql(`
  query GetClassSignups($id: BigInt!, $after: Cursor) {
      fs_signupCollection(filter: {event: {eq: $id}}, after: $after) {
        pageInfo { endCursor startCursor hasNextPage } 
        edges {
          node {
            nodeId
            status
            id
            fs_registrations {
              fs_purchases {
                Package
                fs_students {
                  id
                  FirstName
                  LastName
                  Email
                  Height
                  Weight
                  MedCondFlag
                  MedCondDescr
                  HasEquipment
                  DOB
                  Mobile
                  RegistrationState                  
                }
              }
            }
          }
        }
      }
    }
  `);

export default function EditEvent() {

  const isSmallScreen = useScreenSize();
  const { eventId: eventId } = useParams();
  const { data, loading } = useQuery(getEventQuery, { variables: { id: eventId }, fetchPolicy: 'no-cache' });
  var selectedEvent;
  var noEvent = false;
  if (data && data?.fs_eventsCollection.edges.length) {
    selectedEvent = data?.fs_eventsCollection.edges[0].node;
  }
  else {
    noEvent = true;
  }

  const { data: dataStudents, error: errorStudents, loading: loadingStudents } = useQueryAll<types.Fs_SignupEdge>({ query: getClassSignupsQuery, variables: { id: eventId } });

  const { data: staff_flag } = useQuery(getStaffStatus);
  const staff = staff_flag?.am_i_staff;

  const [valueTab, setValueTab] = useState(staff ? '1' : '5');
  const navigate = useNavigate();

  function onEventUpdate(): void {
    navigate("..", { relative: "path" });
  }

  function onEventDelete(): void {
    navigate("..", { relative: "path" });
  }

  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setValueTab(newValue);
  };
  const selectedEventDate = selectedEvent?.date;


  const date = selectedEventDate && SchoolTime.fromISO(selectedEventDate);

  const formattedDate = date?.toDateTime().toFormat("f");
  const EventName = selectedEvent?.fs_classes.name + ", " + formattedDate;

  return (
    <Card>
      <MDBoxRoot
        component="main" px={2} py={3}
        sx={{ flexGrow: 1, width: '100%' }}
      >
        <Toolbar />

        {selectedEvent &&
          <Grid item xs={9} sx={{ marginTop: "10px" }}>
            <TabContext value={valueTab}>
              <Tabs
                value={valueTab}
                onChange={handleChangeTab}
                textColor="primary"
                aria-label="Edit Event"
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile={true}
              >

                {staff && (<Tab label="Edit Event" value="1" />)}
                {staff && (<Tab label="Attendees" value="2" />)}
                {staff && (<Tab label="Instructors" value="4" />)}
                <Tab label="Event Roster" value="5" />
              </Tabs>
              <MDBoxRoot mt={2} px={1}><MDTypographyRoot align="left">{EventName}</MDTypographyRoot></MDBoxRoot>
              {staff && (<TabPanel value="1" sx={{ paddingLeft: '8px', paddingRight: '8px' }}><EditEventDialog event={selectedEvent} onSave={onEventUpdate} onDelete={onEventDelete} attendies={dataStudents} eventName={EventName} /></TabPanel>)}
              {staff && (<TabPanel value="2"><EditEventAttendees event={selectedEvent} attendies={dataStudents} /></TabPanel>)}
              {staff && (<TabPanel value="4"><EditEventInstructors event={selectedEvent} /></TabPanel>)}
              <TabPanel value="5" sx={{ paddingLeft: '4px', paddingRight: '4px' }}><EventRoster event={selectedEvent} attendies={dataStudents} /> </TabPanel>
            </TabContext>
          </Grid>
        }
        {noEvent && (
          <div>No Event</div>
        )}

      </MDBoxRoot>
    </Card>
  )
}



